import React, {useState} from 'react';
import {connect} from "react-redux";
import moment from 'moment';
import {DateRangePicker} from 'react-dates';
import ValidationError from "~/Components/Forms/ValidationError";
import { TextTranslateString } from '../../../Components/TextTranslate/TextTranslate';
import { CloseIcon } from '../../../Components/Icons/Icons';

const RoomRow = ({onChange, onRemove, values, errors, roomKey, ...props}) => {

    const [dateRangeFocused, setDateRangeFocused] = useState(null);

    const roomTypes = {
        'single': TextTranslateString('hotel-room-type-single', undefined, props.currentLanguage, props.translations) || 'Single',
        'twin': TextTranslateString('hotel-room-type-twin', undefined, props.currentLanguage, props.translations) || "Twin",
        'double': TextTranslateString('hotel-room-type-double', undefined, props.currentLanguage, props.translations) || "Double",
    }

    const defaultFields = {
        qty: '',
        room_type: 'single',
        date_from: null,
        date_to: null,
    };

    const form = {...defaultFields, ...values};

    const handleDateRange = (start, end) => {
        form.date_from = start;
        form.date_to = end;

        onChange(form);
    };

    const handleQtyChange = (e) => {
        form.qty = e.target.value;

        onChange(form);
    };

    const handleRoomTypeChange = (e) => {
        form.room_type = e.target.value;
        onChange(form);
    };

    let roomErrors = {};

    Object.keys(defaultFields).forEach((field) => {
        let key = 'roomData.' + roomKey + '.' + field;
        if (errors) {
            roomErrors[field] = errors[key] || [];
        }
    });

    return (
        <div className="room-row flex-gap mb-4">
            <div className="quantity">
                <input
                    type="number"
                    min="0"
                    onChange={(e) => handleQtyChange(e)}
                    value={form.qty}
                    className="form-control" placeholder="Qty"
                />
                <ValidationError errors={roomErrors} name="qty" />
            </div>
            <div className="roomtype">
                <select
                    defaultValue={form.room_type}
                    onChange={(e) => handleRoomTypeChange(e)}
                    className="form-control"
                    placeholder={TextTranslateString('hotel-room-type', undefined, props.currentLanguage, props.translations) || "Room Type"}
                >
                    {Object.keys(roomTypes).map((type) => {
                        return (
                            <option key={type} value={type}>{roomTypes[type]}</option>
                        )
                    })}
                </select>
                <ValidationError errors={roomErrors} name="room_type" />
            </div>
            <div className="datepicker">
                <DateRangePicker
                    readOnly={true}
                    isRTL={props?.currentLanguage?.rtl}
                    startDatePlaceholderText={TextTranslateString("hotel-room-arrival-date", "Arrival Date", props.currentLanguage, props.translations)}
                    endDatePlaceholderText={TextTranslateString("hotel-room-departure-date", "Departure Date", props.currentLanguage, props.translations)}
                    openDirection={'up'}
                    startDate={form.date_from ? moment(form.date_from).locale(props.currentLanguage.code) : undefined}
                    startDateId={`hotelroom_${roomKey}_start_date`}
                    endDate={form.date_to ? moment(form.date_to).locale(props.currentLanguage.code) : undefined}
                    endDateId={`hotelroom_${roomKey}_end_date`}
                    onDatesChange={({ startDate, endDate }) => handleDateRange(startDate, endDate)}
                    focusedInput={dateRangeFocused}
                    onFocusChange={(focus) => setDateRangeFocused(focus)}
                    showClearDates={true}
                    numberOfMonths={1}
                    monthFormat='MMM YYYY'
                    hideKeyboardShortcutsPanel={true}
                    displayFormat={"dd DD MMM"}
                    renderMonthElement={({ month }) => moment(month).locale(props.currentLanguage.code).format('MMMM YYYY')}
                    renderDayContents={(day) => moment(day).locale(props.currentLanguage.code).format('D')}
                />

                <div className="row">
                    <div className="col-6">
                        <ValidationError errors={roomErrors} name="date_from" />
                    </div>
                    <div className="col-6">
                        <ValidationError errors={roomErrors} name="date_to" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                <a onClick={(e) => {onRemove(e)}}
                    className="link d-flex"
                >
                    <CloseIcon color="#000000" classes="svg-16"/>
                </a>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations,

    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep,
    formData: state.guests?.formData
});

export default connect(mapStateToProps)(RoomRow);
